import React from 'react';
import { InteriorApp } from './pages/InteriorApp';
export function App() {
  return <InteriorApp data-id="element-0" />;
}